export const ariaLabels = {
    describedBy: 'describedBy',
    labelledBy: 'labelledBy',
};
//# sourceMappingURL=ariaLabels.js.map